
import { getBoxValue, ratioCheck } from './utils/functions';
import { getTypoCSS, getColorsCSS } from '../../Components/utils/getCSS';

const Style = ({ attributes, clientId }) => {
	const { columnGap, rowGap, img, image, imgBorder, playerColor, overlyColor, captionTypo, captionColors, btnTypo, btnWidth, btnHeight, btnAlign, btnColors, btnHovColors, btnPadding, btnBorder, btnRadius, btnSpaceBetween } = attributes;

	const newStyles = `
	${getTypoCSS('', btnTypo)?.googleFontLink}
	${getTypoCSS('', captionTypo)?.googleFontLink}
	${getTypoCSS(`#lbbLightBox-${clientId} .lbbLightBox button`, btnTypo)?.styles}
	${getTypoCSS(`#lbbLightBox-${clientId} .lbbLightBox .contentArea .caption p`, captionTypo)?.styles}

	#lbbLightBox-${clientId} .lbbLightBox{
		grid-gap: ${rowGap} ${columnGap};
		justify-content:${btnAlign}; 
	}

	#lbbLightBox-${clientId} .lbbLightBox a{
		width:${btnWidth};
		height:${btnHeight};
	}

	#lbbLightBox-${clientId} .lbbLightBox .contentArea .caption p {
		${getColorsCSS(captionColors)};
	}
	#lbbLightBox-${clientId} .default .contentArea .img{
		padding-top: ${ratioCheck(image?.ratio)}%;
	}

	#lbbLightBox-${clientId} .lbbLightBox img {
		
	}

	#lbbLightBox-${clientId} .lbbLightBox .lbbContent_area {
		border-radius:${img?.borderRadius}px;
		border:${getBoxValue(imgBorder)};
	}

	#lbbLightBox-${clientId} .lbbLightBox .lbbContent_area .contentArea::after {
		background:${overlyColor};
		border-radius:${img?.borderRadius}px;
	}
	
	#lbbLightBox-${clientId} .lbbLightBox.llbButton .flex{
		 justify-content: ${btnAlign}
	}

	#lbbLightBox-${clientId} .lbbLightBox button{
		${getColorsCSS(btnColors)};
		padding:${getBoxValue(btnPadding)};
		border:${getBoxValue(btnBorder)};
		column-gap:${btnSpaceBetween};
		border-radius:${(getBoxValue(btnRadius))};
		width:100%;
		height:100%;
	}
	
	#lbbLightBox-${clientId} .lbbLightBox button:hover{
		${getColorsCSS(btnHovColors)};
	}

	.plyr {
		--plyr-color-main: ${playerColor};
	}
`;

	return <style dangerouslySetInnerHTML={{
		__html: newStyles
	}} />;
}
export default Style;